module.exports = __webpack_public_path__ + "img/Solanum_pimpinellifolium.627abd32.jpg";